import * as TYPES from '../action-type';
import { diffAccount } from '../../utils/utils';

export default function account(
  state = {
    accounts: {
      brokers: [],
      managers: [],
      borrowers: []
    },
    accountsIsGet: false
  },
  action
) {
  switch (action.type) {
    case TYPES.ADD_ACCOUNT:
      state = JSON.parse(JSON.stringify(state));
      const { type } = action.account;
      state.accounts[type].push(action.account);
      break;
    case TYPES.SET_ACCOUNTS:
      state = JSON.parse(JSON.stringify(state));
      state.accounts = diffAccount(action.accounts);
      state.accountsIsGet = true;
      break;
    default:
      break;
  }
  return state;
}
